import { Stack, Title } from '@mantine/core';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { WosIsiReportForm } from '@/module/WosIsiReport/components/WosIsiReportForm';
import { canGenerateWosIsiReport } from '@/module/WosIsiReport/wosIsiReportAccess';

import { Content, NoContentPlaceholder, PendingSpinner } from '@/core/components';

import { useRoleBoundary } from '@feature/security';

export function WosIsiReportPage() {
  const { t } = useTranslation();
  const { isRoleOneOf } = useRoleBoundary();

  return (
    <Stack>
      <Title order={1}>{t('wosIsiReport.title')}</Title>
      {!isRoleOneOf(canGenerateWosIsiReport) && <NoContentPlaceholder title={t('wosIsiReport.errors.forbidden')} />}
      {isRoleOneOf(canGenerateWosIsiReport) && (
        <Content>
          <Suspense fallback={<PendingSpinner h="20vh" />}>
            <WosIsiReportForm />
          </Suspense>
        </Content>
      )}
    </Stack>
  );
}
